import React, { useState, useMemo,useContext } from "react";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import VisibilityIcon from "@mui/icons-material/Visibility";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteCpe } from "services/ConfigServices";
import { statusData } from "variables/lists/cpe";
import CustomDeleteButton from "../CustomDeleteButton/CustomDeleteButton.js";
import UserService from "../../services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import useCPETable from "./useCPETable.js";
import {
  Navigate,
} from "react-router-dom";

const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;
const GroupCell = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const useStyles = makeStyles(styles);

const RTCPE = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const cpeadmin = permis.includes("cpe_admin");
  const advancedSearchContext = useContext(AdvancedSearchContext);
  const { groupInfoListById, setPage } = advancedSearchContext;
  const { gridState, refetch, setSelectedCpes } = useCPETable();
  const [redirState, setRedirState] = useState(false);
  const [cpeId, setCpeId] = useState("");
  const [cpeName, setCpeName] = useState("");
  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/cpe/selectedcpe/",
        state: { cpeId, cpeName },
      }}
      state= {{ cpeId, cpeName }}
    />
  );

  let dataCpes = gridState.data;

  const classes = useStyles();

  const columns = [
    {
      name: "Numéro du contrat",
      selector: (row) => row.parameters.contractnumber,
      sortable: true,
      maxWidth: "9rem",
    },
    {
      name: "Nom",
      selector: (row) => row.parameters.name,
      sortable: true,
     // minWidth: "13rem",
    },
    {
      name: "Statut",
      selector: (row) => row.parameters.status,
      sortable: true,
     // maxWidth: "12rem",
      cell: (row) => row.parameters.status ?
        <div style={{ color: statusData.find((x) => x.id == row.parameters.status).color, fontWeight: "bold" }}>
          {statusData.find((x) => x.id == row.parameters.status).name}
        </div> : <></>
    },
    {
      name: "Date de début",
      sortable: true,
      selector: (row) => row.parameters.datebegin,
      //maxWidth: "10rem",
      cell: (row) =>
        row.parameters.datebegin && moment(row.parameters.datebegin).isValid()
          ? moment(row.parameters.datebegin).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Date de fin",
      sortable: true,
      selector: (row) => row.parameters.dateend,
      //maxWidth: "10rem",
      cell: (row) =>
        row.parameters.dateend && moment(row.parameters.dateend).isValid()
          ? moment(row.parameters.dateend).format("DD/MM/YYYY")
          : "",
    },
    {
      name: "Périmètre",
      selector: (row) => row.idgroup,
      sortable: true,
      cell: (row) => (
        <GroupCell>
          <div>{groupInfoListById["" + row.idgroup]}</div>
        </GroupCell>
      ),
    },
    {
      name: "Performance",
      selector: (row) => row.performance,
      sortable: true,
      width: "8rem",
    },
    {
      name: "",
      sortable: false,
      width: "7rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            <Tooltip title="Voir les détails du contrat">
              <Button
                onClick={CPEDetail(row)}
                color={"info"}
                className={classes.actionButton}
              >
                <VisibilityIcon fontSize="large" />
              </Button>
            </Tooltip>
            {cpeadmin && (
              <CustomDeleteButton
                deleteTitle={"Suppression du contrat"}
                deleteSubTitle={`Êtes-vous sûr de vouloir supprimer le contrat ${row.parameters.name} ?`}
                handleSupprimer={deleteCPEFunction(row)}
              />
            )}
          </div>
        </>
      ),
    },
  ];

  const CPEDetail = (row) => async () => {
    setCpeId(row.id);
    setCpeName(row.parameters.name);
    setRedirState(true);
  };

  const deleteCPEFunction = (row) => async () => {
    let obj = dataCpes.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteCpe(idSelected);
    axios
      .delete(url, {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            `Le CPE ${obj.parameters.name} a été supprimé`
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setSelectedCpes(selection.selectedRows);
  };

  return (
    <>
      <DataTable
          paginationRowsPerPageOptions={[10,20,30,50,100]}
        noDataComponent={<NoData>Aucun CPE à afficher</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        highlightOnHover
        pointerOnHover
        onRowClicked={(row) => {
          setCpeId(row.id);
          setCpeName(row.parameters.name);
          setRedirState(true);
        }}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      {redirecting}
    </>
  );
};

export default RTCPE;
